<template>
  <div class="container py-5">
    <h1 class="mb-2">Set your password</h1>
    <p class="text-muted mb-4">
      Complete this step to access your {{ joinTypeLabel }} dashboard.
    </p>

    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div v-if="success" class="alert alert-success" role="alert">
      Password saved. Redirecting...
    </div>

    <form v-if="!success" @submit.prevent="submit">
      <div class="mb-3">
        <label class="form-label">Password</label>
        <input v-model="password" type="password" class="form-control" required minlength="6" />
      </div>
      <div class="mb-3">
        <label class="form-label">Confirm Password</label>
        <input
          v-model="passwordConfirmation"
          type="password"
          class="form-control"
          required
          minlength="6"
        />
      </div>

      <button class="btn btn-primary w-100" :disabled="submitting">
        {{ submitting ? 'SAVING...' : 'Save password' }}
      </button>
    </form>
  </div>
</template>

<script>
import { PARTNER_PUBLIC_LOGIN_URL } from "@/utils/partnerPublicLoginUrl";

export default {
  name: 'SetPartnerPassword',
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      submitting: false,
      error: '',
      success: false,
      joinType: '',
    };
  },
  computed: {
    token() {
      return this.$route.params?.token || '';
    },
    joinTypeLabel() {
      const j = String(this.joinType || '').toLowerCase();
      if (j === 'salon') return 'salon';
      if (j === 'groomer') return 'groomer';
      return 'partner';
    },
  },
  methods: {
    async submit() {
      this.error = '';
      this.submitting = true;
      try {
        const res = await this.$axios.post(`/partner/set-password/${this.token}`, {
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        });

        if (res?.data?.success) {
          this.joinType = res.data.joinType || '';
          this.success = true;

          // Partner login is on lushgroom.com; this SPA may be opened from admin (API host).
          const host = String(window.location.hostname || '').toLowerCase();
          if (host === 'admin.lushgroom.com') {
            window.location.replace(PARTNER_PUBLIC_LOGIN_URL);
            return;
          }
          this.$router.push({ path: '/login' });
        } else {
          this.error = res?.data?.message || 'Could not save password.';
        }
      } catch (e) {
        this.error = e?.response?.data?.message || 'Could not save password. Please try again.';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

